<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/requisition-widget/requisition-widget.component.ts
-->
<ng-template #anchor></ng-template>
